module.exports = __webpack_public_path__ + "media/images/posts/fingerprints-2efb28ac179d1294597b54db1f7af83b.jpg";